import React, { useState } from "react";
import Loader from "components/Loader";
import Pagination from "components/Pagination";

import useStyles from "./styles";

export interface Props<T> {
  items?: T[];
  pageSize: number;
  pages?: T[][];
  isFetching: boolean;
  renderPage: (items) => React.ReactNode;
  totalCount: number;
  noContentTitle: string;
  additionalContent?: React.ReactNode;
}

function PaginatedList<T>(props: Props<T>) {
  const {
    isFetching,
    pageSize,
    totalCount,
    noContentTitle,
    renderPage,
    items = [],
    pages = [],
    additionalContent
  } = props;
  const classes = useStyles();

  const [activePage, setActivePage] = useState<number>(0);

  const handlePageChange = page => {
    setActivePage(page - 1);
  };

  const renderList = () => {
    if (pageItems) return renderPage(pageItems);

    return <div className={classes.emptyDataHolder}>{noContentTitle}</div>;
  };

  if (isFetching) {
    return <Loader />;
  }

  const pageItems =
    pages[activePage] ||
    items.slice(pageSize * activePage, pageSize + pageSize * activePage);

  return (
    <div className={classes.listContainer}>
      <div className={classes.listContent}>
        {renderList()}
        {additionalContent}
      </div>

      {Boolean(totalCount) && (
        <Pagination
          totalCount={totalCount}
          pageNumber={activePage + 1}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default PaginatedList;
